import React from 'react'
import { BaseIcon } from './Icon.style'

const Icon = ({ className, ...props }) => {
  return <BaseIcon className={className} {...props} />
}

export default Icon
